import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts';
import axios from 'axios'
import request from '@/utils/request'
import VueAxios from 'vue-axios'



Vue.prototype.$echarts = echarts
Vue.use(dataV)
Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.prototype.$axios = axios;
Vue.prototype.$request = request;


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
